import { ChevronDown } from 'lucide-react';
import { identity } from '../mock';

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-[50px] overflow-hidden">
      {/* Decorative watercolour blob behind name */}
      <svg
        className="absolute left-1/2 top-[38%] -translate-x-1/2 -translate-y-1/2 blob-float pointer-events-none"
        width="1100" height="640" viewBox="0 0 1100 640" aria-hidden="true"
      >
        <defs>
          <radialGradient id="blob1" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#C4622D" stopOpacity="0.22" />
            <stop offset="55%" stopColor="#D4A853" stopOpacity="0.12" />
            <stop offset="100%" stopColor="#F5F0E8" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="blob2" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#7A8C6E" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#F5F0E8" stopOpacity="0" />
          </radialGradient>
        </defs>
        <path d="M 210 310 C 180 180, 420 90, 600 140 C 820 200, 970 130, 980 310 C 990 470, 770 540, 560 520 C 330 500, 240 440, 210 310 Z" fill="url(#blob1)"/>
        <ellipse cx="310" cy="460" rx="230" ry="110" fill="url(#blob2)"/>
      </svg>

      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        {/* Availability chip */}
        {identity.statusOpen && (
          <div className="reveal flex justify-center mb-8">
            <span
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-[13px]"
              style={{ background: 'var(--surface)', border: '1px solid var(--border)', color: 'var(--ink-soft)' }}
            >
              <span className="relative flex w-2 h-2">
                <span className="absolute inset-0 rounded-full animate-ping" style={{ background: 'rgba(122,140,110,0.55)' }} />
                <span className="relative inline-flex rounded-full w-2 h-2" style={{ background: '#7A8C6E' }} />
              </span>
              Open to work
            </span>
          </div>
        )}

        {/* Name — two lines */}
        <h1
          className="reveal reveal-delay-2 font-display text-center leading-[0.92] tracking-[-0.02em]"
          style={{ fontSize: 'clamp(72px, 14vw, 192px)', color: 'var(--ink)', fontWeight: 600 }}
        >
          <span className="block">{identity.firstName}</span>
          <span
            className="block italic"
            style={{
              backgroundImage: 'linear-gradient(120deg, #C4622D 0%, #D4A853 55%, #A4501F 100%)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
              fontWeight: 600,
            }}
          >
            {identity.lastName}
          </span>
        </h1>

        {/* Subtitle */}
        <p
          className="reveal reveal-delay-3 text-center mt-8 md:mt-10 text-[14.5px] md:text-[15.5px] tracking-[0.12em] uppercase"
          style={{ color: 'var(--ink-soft)' }}
        >
          {identity.title} <span style={{ color: 'var(--terracotta)' }}>·</span> {identity.company} <span style={{ color: 'var(--terracotta)' }}>·</span> {identity.location}
        </p>

        {/* Handwritten tagline — sits between subtitle and scroll cue */}
        <p
          className="reveal reveal-delay-3 font-hand text-center mt-6 md:mt-8"
          style={{ color: 'var(--terracotta-deep)', fontSize: 'clamp(22px, 2.6vw, 30px)' }}
        >
          making things people actually enjoy using
        </p>

        {/* Scroll cue */}
        <button
          type="button"
          onClick={() => {
            const el = document.getElementById('experience');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}
          aria-label="Scroll to where I've worked"
          className="flex flex-col items-center mt-14 md:mt-16 gap-2 scroll-bob mx-auto bg-transparent border-0 p-0 cursor-pointer group"
        >
          <span className="font-hand text-[18px] transition-colors duration-200 group-hover:text-[color:var(--terracotta-deep)]" style={{ color: 'var(--ink-soft)' }}>scroll</span>
          <ChevronDown size={18} className="transition-transform duration-200 group-hover:translate-y-0.5" style={{ color: 'var(--terracotta)' }} />
        </button>
      </div>
    </section>
  );
}
